import { Vector3 } from 'three';
import type { Area } from 'src/data';
import { store } from 'src/app/store';
import { selectCurrentArea } from 'src/state';
import { camera } from './scene';

let previousAreaId: string | undefined;
store.subscribe(onStateChange);
onStateChange(true);

function onStateChange(instant: boolean = false) {
  const state = store.getState();
  const currentArea = selectCurrentArea(state);

  if (previousAreaId !== currentArea.sys.id) {
    previousAreaId = currentArea.sys.id;
    targetCurrentArea(currentArea, instant);
  }
}

async function targetCurrentArea(area: Area, instant: boolean = false) {
  const newTarget = new Vector3(
    area.fields.cameraTargetX['en-US'],
    area.fields.cameraTargetY['en-US'],
    area.fields.cameraTargetZ['en-US'],
  );

  const newPosition = new Vector3(
    area.fields.cameraPositionX['en-US'],
    area.fields.cameraPositionY['en-US'],
    area.fields.cameraPositionZ['en-US'],
  );

  camera.transitionPositionAndTarget(newPosition, newTarget, instant);
}
